



















































































































































































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { axios } from "../../../plugins";
import { uuid } from "../../../utils/uuid";

const StoangeHeader: Header[] = [
  { title: "容器名称", key: "containerName", width: 200 },
  { title: "类型", key: "type", width: 100 },
  { title: "挂载名称", key: "volumeName", width: 200 },
  { title: "挂载路径", key: "mountPath", width: 100 },
  { title: "是否只读", key: "readOnly", width: 100 },
  { title: "存储类型", key: "storageClass", width: 200 },
  { title: "容量", key: "capacity", width: 100 },
  { title: "访问模式", key: "model", width: 150 }
];

const EnvHeader: Header[] = [
  { title: "容器名称", key: "containerName", width: 200 },
  { title: "环境变量类型", key: "envType", width: 180 },
  { title: "环境变量名称", key: "name", width: 180 },
  { title: "引用源配置key", key: "sourceKey", width: 180 },
  { title: "引用源配置名称", key: "sourceName", width: 180 },
  { title: "环境变量值", key: "value", width: 180 }
];

const EventHeader: Header[] = [
  { title: "类型", key: "involvedObject.kind", width: 130 },
  { title: "对象", key: "involvedObject.name", width: 140 },
  { title: "消息", key: "message", width: 280 },
  { title: "原因", key: "reason", width: 210 },
  { title: "时间", key: "metadata.creationTimestamp", width: 180 }
];
// 部署类型
const TypeEnum = {
  Deployment: "无状态服务",
  StatefulSet: "有状态服务",
  DaemonSet: "守护进程"
};
// 拉取策略
const PullEnum = {
  IfNotPresent: "优先使用本地镜像",
  Always: "尝试重新下载镜像",
  Never: "仅使用本地镜像"
};
export default Vue.extend({
  name: "Overview",
  props: {
    data: { type: Object },
    type: { type: String },
    projectId: { type: String }
  },
  data() {
    return {
      StoangeHeader,
      EnvHeader,
      EventHeader,
      TypeEnum,
      PullEnum,
      sLoading: false,
      storageData: [],
      eLoading: false,
      envsData: [],
      vLoading: false,
      events: [],
      autoScale: null
    };
  },
  mounted() {
    this.getStorages();
    this.getEnvs();
    this.getEvent();
    this.getAutoScale();
  },
  methods: {
    refush() {
      this.getStorages();
      this.getEnvs();
      this.getEvent();
      this.getAutoScale();
    },
    getStorages() {
      let url = "";
      if (this.type === "无状态组件") {
        url = "/deployment/";
      } else if (this.type === "有状态组件") {
        url = "/statefulset/";
      }
      this.sLoading = true;
      axios
        .get(`${url}${this.projectId}/${this.data.metadata.name}/storage`)
        .then(res => {
          this.storageData = res.data.data;
        })
        .finally(() => {
          this.sLoading = false;
        });
    },
    getEnvs() {
      let url = "";
      if (this.type === "无状态组件") {
        url = "/deployment/";
      } else if (this.type === "有状态组件") {
        url = "/statefulset/";
      }
      this.eLoading = true;
      axios
        .get(`${url}${this.projectId}/${this.data.metadata.name}/env`)
        .then(res => {
          this.envsData = res.data.data;
        })
        .finally(() => {
          this.eLoading = false;
        });
    },
    getEvent() {
      this.vLoading = true;
      let loadType = "";
      if (this.type === "无状态组件") {
        loadType = "Deployment";
      } else if (this.type === "有状态组件") {
        loadType = "StatefulSet";
      }
      axios
        .get(
          `/event/list/app?app=${this.data.metadata.name}&projectId=${
            this.projectId
          }&loadType=${loadType}&size=9999&page=1&listId=${uuid()}`
        )
        .then(res => {
          this.events = res.data.data.list;
        })
        .finally(() => {
          this.vLoading = false;
        });
    },
    getAutoScale() {
      let loadType = "";
      if (this.type === "无状态组件") {
        loadType = "Deployment";
      } else if (this.type === "有状态组件") {
        loadType = "StatefulSet";
      }
      axios
        .get(
          `/autoscaling/${this.projectId}?loadType=${loadType}&app=${this.data.metadata.name}`
        )
        .then(res => {
          this.autoScale = res.data.data;
        });
    },
    handleCommand(type: string) {
      if (type === "delete") {
        axios
          .delete(
            // @ts-ignore
            `/autoscaling/${this.projectId}/${this.autoScale.metadata.name}`
          )
          .then(() => {
            this.$message.success("伸缩策略删除成功！");
            this.getAutoScale();
          });
      }
    }
  }
});
